import { useEffect, useState } from "react";
import { Award, Target, Crosshair, Swords, Skull, TrendingUp, Flame, Lock, Check } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { Loader } from "@/components/common/Loader";
import { cn } from "@/lib/utils";
import { api } from "@/lib/api";

const ICONS = { award: Award, target: Target, crosshair: Crosshair, swords: Swords, skull: Skull, "trending-up": TrendingUp, flame: Flame };

export default function Achievements() {
    const [items, setItems] = useState(null);
    useEffect(() => { api.get("/achievements").then(({ data }) => setItems(data.achievements)); }, []);
    if (!items) return <Loader label="Loading achievements" />;

    const unlocked = items.filter((a) => a.unlocked).length;

    return (
        <div className="ww-fade-up">
            <PageHeader title="Achievements" subtitle={`${unlocked} of ${items.length} unlocked — keep pushing.`} />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {items.map((a) => {
                    const Icon = ICONS[a.icon] || Award;
                    const pct = Math.round((a.progress / a.target) * 100);
                    return (
                        <div key={a.id} data-testid={`achievement-${a.key}`}
                            className={cn("bg-surface border rounded-sm p-5 transition-colors", a.unlocked ? "border-volt/40" : "border-border")}>
                            <div className="flex items-start gap-4">
                                <div className={cn("grid place-items-center w-12 h-12 rounded-sm shrink-0", a.unlocked ? "bg-volt/15 text-volt" : "bg-obsidian text-muted-foreground")}>
                                    <Icon className="w-6 h-6" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2">
                                        <span className="font-heading font-bold text-white">{a.title}</span>
                                        {a.unlocked ? <Check className="w-4 h-4 text-success" /> : <Lock className="w-3.5 h-3.5 text-muted-foreground" />}
                                    </div>
                                    <p className="text-xs text-muted-foreground mt-0.5">{a.description}</p>
                                    <div className="mt-3">
                                        <div className="h-1.5 bg-obsidian rounded-full overflow-hidden">
                                            <div className={cn("h-full rounded-full transition-all duration-700", a.unlocked ? "bg-success" : "bg-volt")} style={{ width: `${Math.min(100, pct)}%` }} />
                                        </div>
                                        <div className="text-[11px] font-mono text-muted-foreground mt-1">{Math.min(a.progress, a.target)} / {a.target}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
